import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import {AppConfig} from "./app/app-config";
import {API_BASE_URL} from "@core/service/kim-teilnehmer-rest-api";

if (environment.production) {
  enableProdMode();
}

fetch('/api/configuration/frontend')
  .then((response: Response) => {
    if (response.ok) {
      // Get body
      return response.json();
    } else {
      // Fail startup
      return Promise.reject(response);
    }
  })
  .then((response: AppConfig | Response) => {
    if ('production' in response) {
      const appconfig = response as AppConfig;

      environment.production = appconfig.production;
      environment.api_url = appconfig.api_url;
      environment.env = appconfig.env;
      environment.registrationEnabled = appconfig.registration_activated;
      environment.registrationDeactivationDate = appconfig.registration_deactivation_date;


      if (appconfig.production) {
        enableProdMode();
      }

      platformBrowserDynamic(
        [
          {
            provide: API_BASE_URL,
            useValue: appconfig.api_url,
          }
        ]
      )
        .bootstrapModule(AppModule)
        .catch(err => console.error(err));
    }
  });
